/* angular:styles/component:css;a9dff9291fd5137adb1d14ea12a82e75e3d3d77ec411434b510f9a7fc977a62d;/src/src/app/shared/components/formly/formly-field-checkbox-image/formly-field-checkbox-with-image.ts */
.center-image {
  display: block;
  margin-left: auto;
  margin-right: auto;
  max-width: 10rem;
  height: auto;
}
.resize-image {
  max-width: 20rem;
  height: auto;
}
.input-box {
  border: 0.1em solid var(--ion-color-dark);
  border-radius: 0.125rem;
  width: 100%;
  padding-left: 0.5rem;
  --min-height: auto;
  --border-color: var(--ion-color-medium);
  transition: border-color 0.3s;
}
.disabled-sub-field {
  pointer-events: none;
  opacity: 0.5;
}
.help-icon {
  vertical-align: middle;
  font-size: 1.1em;
  margin-left: 0.25rem;
  color: var(--ion-color-medium-shade);
  cursor: help;
}
@media (max-width: 600px) {
  .resize-image {
    max-width: 10rem;
    height: auto;
  }
}
/*# sourceMappingURL=formly-field-checkbox-with-image.css.map */
